import { render, staticRenderFns } from "./image-controller.vue?vue&type=template&id=2fa83a2c&scoped=true&"
import script from "./image-controller.vue?vue&type=script&lang=js&"
export * from "./image-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa83a2c",
  null
  
)

export default component.exports